import api from "./api";

export async function getConfig() {
  try {
    var response = await api.get(
      "api/configuration"
    );
    return response.data;
  } catch (error) {
    return false;
  }
}
